//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { ClickAndCollectMediumSVG } from './svg'

interface ClickAndCollectMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const ClickAndCollectMediumIcon: React.FC<ClickAndCollectMediumIconProps> = forwardRef<
  ClickAndCollectMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={ClickAndCollectMediumSVG}
    sx={sx}
  />
))
